import { useLocation } from 'react-router-dom'

import { AddToClassModal } from 'modules/trainings/components/Revamp/TrainingsDetail/TrainingEmployeesDataTable/AddToClassModal'
import { BulkSelection } from 'modules/trainings/components/Revamp/TrainingsDetail/ParticipantsOneDataTable/hooks/useBulkActionsConfig'

interface LocationState {
  selection?: BulkSelection
}

const isLocationState = (state: unknown): state is LocationState => {
  return (
    typeof state === 'object' &&
    state !== null &&
    ('selection' in state || Object.keys(state).length === 0)
  )
}

const toBackendSelection = (selection: BulkSelection) => {
  if (selection.type === 'all') {
    return {
      type: 'all' as const,
      excludedIds: selection.excludedIds,
    }
  }
  return undefined
}

const AssignParticipants = () => {
  const location = useLocation()

  if (!isLocationState(location.state) || !location.state.selection) {
    return <AddToClassModal accessIds={[]} />
  }

  const { selection } = location.state

  if (selection.type === 'all') {
    return <AddToClassModal selection={toBackendSelection(selection)} filters={selection.filters} />
  }

  return <AddToClassModal accessIds={selection.ids} />
}

export default AssignParticipants
